export default "__VITE_ASSET__CEcSgBYu__"